import { render } from "./map.vue?vue&type=template&id=3863392b"
import script from "./map.vue?vue&type=script&setup=true&lang=ts"
export * from "./map.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3863392b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3863392b', script)) {
    api.reload('3863392b', script)
  }
  
  module.hot.accept("./map.vue?vue&type=template&id=3863392b", () => {
    api.rerender('3863392b', render)
  })

}

script.__file = "resources/scripts/components/ui/map.vue"

export default script